import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReservationsRoutes } from '../../../Router/path';

export const useReservationTable = () => {
  const [selectedReservationIds, setSelectedReservationIds] = useState<number[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  const handleEdit = (id: number, items: Array<{ id: number }>) => {
    const item = items.find((item) => item.id === id);
    if (item) {
      const updatePath = ReservationsRoutes.update.replace(':reservationId', item.id.toString());
      const isFromBookingUpdate = /^\/bookings\/update\/\d+$/.test(location.pathname);

      if (isFromBookingUpdate) {
        const returnTo = `${location.pathname}${location.search}${location.hash}`;
        navigate(`${updatePath}?returnTo=${encodeURIComponent(returnTo)}`);
        return;
      }

      navigate(updatePath);
    }
  };

  return {
    selectedReservationIds,
    setSelectedReservationIds,
    handleEdit,
  };
};
